export default __webpack_public_path__ + "static/media/logo.ff877cb3.svg";